"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/environmentSelectionService',["require", "exports", "knockout", "routing/mainRouter", "controllers/environmentSelectionController", "messenger", "services/sentinelService"], function (require, exports, ko, mainRouter, environmentSelectionController, messenger, sentinelService) {
    "use strict";

    var EnvironmentSelectionService = function () {
        function EnvironmentSelectionService() {
            var _this = this;

            _classCallCheck(this, EnvironmentSelectionService);

            this.selectedEnvironment = ko.observable();
            this.environments = ko.observableArray();
            this.disableRouteSelection = false;
            messenger.on('identity:logout', function () {
                _this.reset();
            });
            this.environmentSubscription = mainRouter.router.environmentId.subscribe(function (environmentId) {
                if (!_this.disableRouteSelection) {
                    _this.selectEnvironmentById(environmentId);
                } else {
                    _this.disableRouteSelection = false;
                }
            });
            this.selectedEnvironmentSubscription = this.selectedEnvironment.subscribe(function (environment) {
                if (environment) {
                    environmentSelection.setEnvironment(environment);
                    messenger.trigger('environment:changed', environment.id);
                }
            });
        }

        _createClass(EnvironmentSelectionService, [{
            key: "setEnvironment",
            value: function setEnvironment(env) {
                window.sessionStorage['SelectedEnvironment'] = env.id;
            }
        }, {
            key: "loadEnvironments",
            value: function loadEnvironments() {
                var _this2 = this;

                this.reset();
                environmentSelectionController.getEnvironmentsForUser().then(function (environments) {
                    if (environments == null) {
                        return;
                    }
                    $.each(environments, function (ind, env) {
                        if (!_this2.environments().find(function (e) {
                            return e.name === env.name;
                        })) {
                            _this2.environments.push({ id: env.name.toLowerCase(), name: env.name });
                        }
                    });
                    if (mainRouter.router.environmentId()) {
                        _this2.disableRouteSelection = true;
                        _this2.selectEnvironmentById(mainRouter.router.environmentId());
                    } else {
                        var sessionEnvironment = window.sessionStorage['SelectedEnvironment'];
                        if (sessionEnvironment) {
                            _this2.disableRouteSelection = true;
                            _this2.selectEnvironmentById(sessionEnvironment);
                        }
                    }
                    if (!_this2.selectedEnvironment()) {
                        if (_this2.environments().length === 1) {
                            _this2.disableRouteSelection = true;
                            _this2.selectedEnvironment(_this2.environments()[0]);
                        } else if (_this2.environments().length === 2) {
                            _this2.disableRouteSelection = true;
                            _this2.selectedEnvironment(_this2.environments()[1]);
                        } else if (_this2.environments().length > 2) {
                            _this2.disableRouteSelection = true;
                            _this2.selectedEnvironment(_this2.environments()[2]);
                        }
                    }
                    if (_this2.environments().length === 1) {
                        messenger.trigger('environment:hide-selector');
                    }
                    messenger.trigger('environments');
                }).always(function () {
                    messenger.trigger('policies:set-selector-vis');
                });
            }
        }, {
            key: "selectEnvironmentById",
            value: function selectEnvironmentById(environmentId) {
                if (environmentId) {
                    var environmentById = this.environments().find(function (e) {
                        return e.id === environmentId.toLowerCase();
                    });
                    if (environmentById) {
                        if (this.selectedEnvironment() == null || environmentById.name !== this.selectedEnvironment().name) {
                            sentinelService.logEnvironmentChange(environmentById.name);
                        }
                        this.selectedEnvironment(environmentById);
                    }
                }
            }
        }, {
            key: "reset",
            value: function reset() {
                this.environments.removeAll();
                this.selectedEnvironment(null);
            }
        }, {
            key: "dispose",
            value: function dispose() {
                this.environmentSubscription.dispose();
                this.selectedEnvironmentSubscription.dispose();
            }
        }]);

        return EnvironmentSelectionService;
    }();

    var environmentSelection;
    environmentSelection = new EnvironmentSelectionService();
    return environmentSelection;
});
//# sourceMappingURL=environmentSelectionService.js.map;
